﻿import {UIText} from "../Tools/Base/UIText";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {NUtils} from "../../Utils/NUtils";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {UISprite} from "../Tools/Base/UISprite";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {RewardType} from "../../enums";
import {Time} from "../../Utils/Unity/Time";

export const PRODUCT_STARTER_PACK = "starter_pack";

class DiamondsBadge extends UISprite {

    Awake() {
        super.Awake();
        this.back = this.addChild(new UISprite("ribbon"));
        this.back.anchor.set(1, 0);
        this.label = this.addChild(new UILabeledIcon({
            label: "+60",
            icon: "ico-diamond",
            iconAlign: "right"
        }));
    }

    fitLayout(rect) {
        rect = rect.clone();
        this.position.copyFrom(rect);

        rect.x = rect.y = 0;
        let badgeRect = rect.clone();
        this.back.scale.set(badgeRect.height / this.back.texture.height);
        this.back.position.set(badgeRect.right + this.back.width * 0.1, 0);

        rect = new PIXI.Rectangle(this.back.x - this.back.width, 0, this.back.width, this.back.height);
        rect.pad(-rect.width * 0.15, -rect.height * 0.2);
        rect.x = badgeRect.right - rect.width;
        rect.y -= this.back.height * 0.05;
        this.label.fitLayout(rect);
    }
}

export class UIStarterPackPopup extends UICommonPopup {

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("starter_pack"),
            closeButton: true,
            skin: "magenta",
        });

        this.OnProductPurchased = this.OnProductPurchased.bind(this);

        this.timerField = this.content.addChild(new UILabeledIcon({
            label: "",
            icon: "ico-clock",
            iconAlign: "absolute-left",
            iconSize: 1.4,
            backgroundColor: 0x000000,
            backgroundAlpha: 0.3,
            textProps: {
                fitTextTemplate: "00h 00m 00s",
            }
        }));

        this.decorChest = this.content.addChild(new UISprite("bank/pack-gems-case"));
        this.decorNoAds = this.content.addChild(new UISprite("offers/noads"));
        this.description = this.content.addChild(new UIText(Core.Localizator.Get("no_ads_description")));
        this.btnBuy = this.content.addChild(new UINineSliceButton("btn-orange"));

        this.badge = this.content.addChild(new DiamondsBadge());

        this.endDateTime = 0;
        this.lastUpdateTime = 0;

        Core.Store.on("Purchased", this.OnProductPurchased);
        this.btnBuy.on("pointertap", () => {
            Core.Store.BuyProductID(PRODUCT_STARTER_PACK);
        });
    }

    get available() {
        return Core.Store.ProductAvailable(PRODUCT_STARTER_PACK, true);
    }

    Init() {
        if (!this.available) return;

        let product = Core.Store.GetProduct(PRODUCT_STARTER_PACK);
        this.btnBuy.label = product.GetPrice();

        let diamondsAmount = product.rewards.find(reward => reward.type === RewardType.MoneyHard);
        diamondsAmount = diamondsAmount && diamondsAmount.value || 0;
        this.badge.SetActive(diamondsAmount > 0);
        this.badge.label.text = "+" + diamondsAmount;
    }

    OnProductPurchased(product) {
        if (product.id === PRODUCT_STARTER_PACK) {
            this.Hide();
        }
    }

    fitLayout(viewport = Core.app.viewport) {
        let aspectRatio = 1.5;
        let w = viewport.width * 0.9, h = w * aspectRatio;
        if (h > viewport.height * 0.9) {
            h = viewport.height * 0.9;
            w *= h / (w * aspectRatio);
        }
        this.setPopupSize(w, h);

        super.fitLayout(viewport);
        let contentRect = this.getContentSize();

        let timerRect = contentRect.clone().pad(-contentRect.width * 0.3);
        timerRect.y = contentRect.height * 0.15;
        timerRect.height = contentRect.width * 0.05;
        this.timerField.fitLayout(timerRect);

        let decorRect = contentRect.clone().pad(-contentRect.width * 0.1, -contentRect.height * 0.25);
        decorRect.y = contentRect.height * 0.2;
        this.decorChest.fitRect(decorRect);

        decorRect.pad(0, -decorRect.height * 0.3);
        this.decorNoAds.fitRect(decorRect);

        let descRect = contentRect.clone().pad(-contentRect.width * 0.1, 0);
        descRect.y = contentRect.height * 0.65;
        descRect.height = contentRect.height * 0.1;
        this.description.fitLayout(descRect);

        let btnRect = contentRect.clone().pad(-contentRect.width * 0.3, 0);
        btnRect.height = btnRect.width / 2;
        btnRect.y = contentRect.height * 0.95 - btnRect.height;
        this.btnBuy.fitLayout(btnRect);

        let badgeRect = btnRect.clone();
        badgeRect.width = contentRect.width * 0.4;
        badgeRect.height *= 0.75;
        badgeRect.x = contentRect.right - badgeRect.width;
        badgeRect.y = btnRect.top - badgeRect.height * 0.9;
        this.badge.fitLayout(badgeRect);
    }

    Show() {
        if (!Core.Store.IsInitialized) return;
        // if (!this.available) return;
        if (!Core.Time.Initialized) return;
        if (!Core.Player.Initialized) return;
        if (Core.Player.Timers.starterPackTime == 0) return;

        this.Init();

        let starterPackStartTime = new Date(Core.Player.Timers.starterPackTime).getTime();
        this.endDateTime = starterPackStartTime + 3600 * 24 * 1000;

        if (this.endDateTime > Core.Time.serverTime && Core.Player.StarterPack != 1) {
            super.Show();
            this.SendAnalyticEvent("show");
            this.updateTime();
        }
    }

    SendAnalyticEvent() {
        Core.Analytics.SendOfferEvent("starter_pack");
    }

    Update() {
        this.lastUpdateTime += Time.deltaTime;

        if (this.lastUpdateTime > 1) {
            this.updateTime();
            this.lastUpdateTime = 0;
        }

        if (Core.Player.StarterPack == 1) {
            this.Hide();
        }
    }

    updateTime() {
        let timeLeft = (this.endDateTime - Core.Time.serverTime) / 1000;
        this.timerField.text = NUtils.FormatSecondsToTime(timeLeft);
        if (timeLeft <= 0) {
            this.SetActive(false);
        }
    }
}
